import { DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { Illustration, Text, Title } from "@src/appV2/redesign/system/ui-components";

import { type StepAction } from "../types";

export interface CompletionStepProps {
  onAction: (action: StepAction) => void;
}

export function CompletionStep({ onAction }: CompletionStepProps) {
  return (
    <>
      <DialogContent sx={{ display: "flex", alignItems: "center" }}>
        <Stack spacing={6} alignItems="center" sx={{ px: 0, width: "100%" }}>
          <Illustration type="review-sent" />

          <Title variant="h3" component="h3" textAlign="center">
            Thank you for your review!
          </Title>

          <Text variant="body1" textAlign="center" color="text.secondary">
            Your feedback is incredibly valuable to the community.
          </Text>
        </Stack>
      </DialogContent>

      <DialogFooter orientation="vertical">
        <Button
          fullWidth
          size="large"
          variant="brand"
          onClick={() => {
            onAction({ type: "CLOSE_FLOW" });
          }}
        >
          Finish
        </Button>
      </DialogFooter>
    </>
  );
}
